import React, { useState } from 'react'
import PopoverConfirm, { PopoverConfirmProps } from './popover-confirm'

const PopverConfirm2: React.FC<PopoverConfirmProps> = props => {
    const [visible, setVisible] = useState(false)
    const hidden = () => {
        setVisible(false)
    }

    return (
        <PopoverConfirm
            visible={visible}
            onVisibleChange={visible => {
                setVisible(visible)
            }}
            types="error"
            onCancel={hidden}
            onConfirm={() => {
                props.onConfirm && props.onConfirm()
                hidden()
            }}
            content={props.content}
            {...props}
        >
            {props.children}
        </PopoverConfirm>
    )
}

export default PopverConfirm2
